import React, { useRef, useState, useEffect } from "react"
import { useTranslation } from 'react-i18next';


import { useHookStore } from "../../../hook-store/store"
// import { resizeImageFile } from '../../utils/image/image-utils';
import { marks } from '../../../utils/marks';

import "../DiffusionOptionsDesc/DiffusionOptionsDesc.css";

import StepInputImage from "../../../image/for-style-change/for-about/sch-turban-woman-input-h125.jpeg"
import StepMaskImage from "../../../image/for-style-change/for-about/sch-turban-woman-mask-h100.jpeg"
import StepStyleImage from "../../../image/for-style-change/for-about/sch-style-abstract-crop-h100.jpeg";
import StepOutputImage1 from "../../../image/for-style-change/option-description/step/turban-woman-output-abstract-stp4-h125.jpeg";
import StepOutputImage2 from "../../../image/for-style-change/option-description/step/turban-woman-output-abstract-stp8-h125.jpeg";

function StyleChangeDescStep() {
    
    const [t] = useTranslation('translation');
  
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const [hStore, hDispatch] = useHookStore();
    const { 
      // inputEta
    } = hStore.iopaintStore;

    return (
      <div className="diffsionOptionDesc">
        <div className="diffsionOptionDescRow">
          {t('syleChangeOptions14', 'User can control output image by changeing this input.')}
          {' '}
          {t('syleChangeOptions15', 'Higher value transfer more styles, and incorporate information of other inputs, but it takes longer time to generate image.')}
          <br/>
          a-steps 3,{' '}
          {t('syleChangeOptions18', 'is good starting point for image generation.')}
        </div>
        <div className="diffsionOptionDescRow">
          <div className="diffsionOptionDescImages">
            <div>
              <img className="diffsionOptionDescImage"
                src={StepInputImage}
              />
              {t('aboutPage.13', 'Input image')}
            </div>
            <div>
              <img className="diffsionOptionDescImage"
                src={StepMaskImage}
              />
              {t('aboutStyleChange05', 'Selected part')}
            </div>
            <div>
              <img className="diffsionOptionDescImage"
                src={StepStyleImage}
              />
              {t('aboutStyleChange06', 'Style image')}
            </div>
          </div>
        </div>
        <div className="diffsionOptionDescRow">
          <div className="diffsionOptionDescImages">

            <div>
              <img className="diffsionOptionDescImage"
                src={StepOutputImage1}
              />
                4
            </div>
            <div>
              <img className="diffsionOptionDescImage"
                src={StepOutputImage2}
              />
                8
          </div>
        </div>
      </div>
    </div>
    )
  }


export default StyleChangeDescStep